var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("CollapseResource", {
        attrs: {
          title: _vm.tabList[0].tab,
          actionUrl: _vm.tabList[0].url,
          sortDictCode: "research_sort",
          actionType: _vm.tabList[0].key,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }